import { render, staticRenderFns } from "./TableDeliveredVoip.vue?vue&type=template&id=115e87f0&scoped=true&"
import script from "./TableDeliveredVoip.vue?vue&type=script&lang=js&"
export * from "./TableDeliveredVoip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115e87f0",
  null
  
)

export default component.exports